import http from '@/communication/AuthConnection'

export default ({ supplierId }) => {
  return http.get(`/v1/suppliers/supplier/${supplierId}`)
    .then(pData => pData.data)
    .catch(() => { return [] })
}



// WEBPACK FOOTER //
// ./src/brain/record/suppliers/load-supplier-data/index.js